import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CookieConsentService } from '../../core/services/cookie-consent.service';
@Component({
  selector: 'app-landing-page-footer',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './landing-page-footer.component.html',
  styleUrl: './landing-page-footer.component.scss',
})
export class LandingPageFooterComponent {
  readonly currentYear = new Date().getFullYear();

  constructor(private readonly cookieConsentService: CookieConsentService) {}

  openCookiePreferences(event: Event): void {
    const opener =
      event.currentTarget instanceof HTMLElement ? event.currentTarget : null;
    this.cookieConsentService.openPreferences(opener);
  }
}
